import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  cropIssueList: [],
  isCropIssueLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_CROP_ISSUES_LIST_SUCCESS:
    case actionTypes.GET_CROP_ISSUES_LIST_ERROR:
      if (action.payload.cropIssueList) {
        state.cropIssueList = action.payload.cropIssueList.map(issue => {
          return {
            ...issue,
            label: issue.name,
            value: issue.uuid,
          };
        });
      } else {
        state.cropIssueList = [];
      }
      return Object.assign({}, state, state.cropIssueList);
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.GET_CROP_ISSUES_LIST:
          return Object.assign({}, state, { isCropIssueLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.GET_CROP_ISSUES_LIST:
          return Object.assign({}, state, { isCropIssueLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
